'use client';

import { useEffect } from 'react';
import { mutate } from 'swr';
import { ThankYou, ThankYouPending } from 'components/ui/organisms';
import { getEnvOrFail } from 'env/env';
import { setIsCTADisabled, useAppDispatch } from 'store';
import {
  THANK_YOU_PAYMENT_STATUS_PARAM,
  THANK_YOU_PAYMENT_STATUS_PROCESSING,
} from 'frontastic/hooks/useCheckout/constants';
import { TasticProps } from '../types';
import { ThankYouDataSource } from './types';

export const ThankYouTastic = ({
  data,
  searchParams,
}: TasticProps<ThankYouDataSource>) => {
  const dispatch = useAppDispatch();
  const { order, program } = data.order.dataSource;
  const isPaymentProcessing =
    searchParams?.[THANK_YOU_PAYMENT_STATUS_PARAM] ===
    THANK_YOU_PAYMENT_STATUS_PROCESSING;

  // clear the CTA state and getCart cache on mount
  useEffect(() => {
    dispatch(setIsCTADisabled(false));
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    mutate('/action/cart/getCart', undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!order) {
    if (isPaymentProcessing) {
      return <ThankYouPending />;
    }

    const learnerDashboardUrl = getEnvOrFail(
      'NEXT_PUBLIC_EDX_LEARNER_DASHBOARD_URL',
    );
    window.location.replace(learnerDashboardUrl);
    return null;
  }

  return <ThankYou order={order} program={program} />;
};
